var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flag-container" },
    [
      _vm.subscribed
        ? _c(
            "el-popover",
            {
              attrs: {
                placement: "bottom",
                trigger: "hover",
                width: "300",
                disabled: !(_vm.hub || _vm.reports.length),
                "open-delay": 200,
                "close-delay": 100,
              },
              on: {
                show: function ($event) {
                  return _vm.selectPopover(_vm.tid)
                },
                hide: function ($event) {
                  return _vm.selectPopover(null)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "recent-articles" },
                [
                  _vm.hub
                    ? _c("nuxt-link", { attrs: { to: _vm.hub } }, [
                        _vm._v(" " + _vm._s(_vm.name) + " Hub "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.reports, function (article) {
                return _c(
                  "div",
                  { key: article.nid, staticClass: "recent-articles" },
                  [
                    _c("nuxt-link", { attrs: { to: article.url } }, [
                      _vm._v("\n        " + _vm._s(article.title) + "\n      "),
                    ]),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "reference" }, slot: "reference" },
                [
                  _c("Country", {
                    staticClass: "flags",
                    attrs: {
                      text: _vm.name,
                      link: _vm.link,
                      iso: _vm.iso,
                      access: _vm.subscribed == 1 ? true : false,
                      icon: _vm.flag,
                      size: "small",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.subscribed
        ? _c(
            "div",
            { attrs: { slot: "reference" }, slot: "reference" },
            [
              _c("Country", {
                staticClass: "flags",
                class: _vm.subscribed == 0 ? "transparent" : null,
                attrs: {
                  text: _vm.name,
                  link: _vm.link,
                  iso: _vm.iso,
                  access: _vm.subscribed == 1 ? true : false,
                  icon: _vm.flag,
                  size: "small",
                },
              }),
              _vm._v(" "),
              _c("Tooltip", { attrs: { size: "small" } }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }